import React from "react";
import { Select } from "antd";

interface PropsOwn {
  [key: string]: any
}

type AllProps = PropsOwn;

/**
 * 共同Modal
 * 限制下拉列表跟随body滚动
 *
 * @class MsSelect
 * @extends {React.Component<AllProps>}
 */
class VhSelect extends React.Component<AllProps> {
  // 渲染
  public render() {
    const getPopupContainer = (triggerNode: any) => triggerNode.parentNode;
    return <Select {...this.props} getPopupContainer={ getPopupContainer } />
  }
}

export default VhSelect;
